import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import history from "../../../managers/history";
import { Loader } from "../../../common/components/loader";
import moment from "moment";
import PropTypes from "prop-types";

const ConsentDetailComponent = (props) => {
  const states = props?.states;

  if (states.isLoading) {
    return <Loader modifyLoader={"text-purple-6C36B0"} />;
  }

  const [openSubConsents, setOpenSubConsents] = useState({});

  const toggleSubConsent = (keyId) => {
    setOpenSubConsents((prevState) => ({
      ...prevState,
      [keyId]: !prevState[keyId]
    }));
  };

  return (
    <div className="mt-5">
      <div className="flex w-full flex-col">
        <div className="flex items-center px-2 md:pl-12.5">
          <IoIosArrowBack
            onClick={() => history.push("/consent")}
            className="size-7 cursor-pointer text-black-20 md:h-4.5 md:w-15px"
          />
          <div className="ml-1 mt-0 break-all font-MontserratRegular text-ft14-17 md:ml-2 md:text-ft16-28">
            {states?.consentData?.userId?.walletAddress}
          </div>
        </div>
        {states?.consentData?.consents?.length > 0 && (
          <>
            <div className="mt-23px flex w-full max-w-224.5 items-center justify-between px-3 md:px-0">
              <div className="font-MontserratSemiBold text-ft13-15.85-0.26 md:pl-12.5 md:text-ft15-18.29-0.3">
                Provided Consent
              </div>
              <div className="mr-14 font-MontserratSemiBold text-ft13-15.85-0.26 md:mr-0 md:w-37 md:pl-12.5 md:text-ft15-18.29-0.3">
                Updated on
              </div>
            </div>
            <div className="md:pr-7.5">
              <hr className="mb-2.5 mt-3 text-grey-E3E3E3 md:mb-4 md:mt-21px" />
            </div>
          </>
        )}
      </div>

      <div className="flex w-full flex-col gap-3 md:pl-12.5 md:pr-2">
        {states?.consentData?.consents?.map((element) => (
          <React.Fragment key={element?.key?._id}>
            <div className="flex w-full max-w-224.5 items-center justify-between px-3 md:px-0">
              <div className="flex items-center gap-2">
                <div className="font-PoppinsRegular text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                  {element.key.name}
                </div>
                {element?.subConsents?.length > 0 ? (
                  openSubConsents[element?.key?._id] ? (
                    <img
                      src="/images/arrow-up.svg"
                      alt="Up arrow"
                      onClick={() => toggleSubConsent(element?.key?._id)}
                      className="cursor-pointer"
                    />
                  ) : (
                    <img
                      src="/images/arrow-down.svg"
                      alt="Down arrow"
                      onClick={() => toggleSubConsent(element?.key?._id)}
                      className="cursor-pointer"
                    />
                  )
                ) : (
                  ""
                )}
              </div>
              <div className="font-PoppinsRegular text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                {moment(element.updatedOn)
                  .utcOffset("+05:30")
                  .format("hh:mm A, DD MMM YYYY")}
              </div>
            </div>

            {openSubConsents[element?.key?._id] &&
              element?.subConsents?.length > 0 &&
              element?.subConsents
                .filter((subElement) => subElement.isAccepted)
                .map((subElement) => (
                  <div
                    key={subElement?.key?._id}
                    className="flex w-full max-w-224.5 items-center justify-between px-3 md:px-0"
                  >
                    <div className="flex gap-2">
                      <div className="font-PoppinsMedium text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                        {subElement?.key?.name}
                      </div>
                    </div>
                    <div className="font-PoppinsMedium text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                      {moment(subElement?.updatedOn)
                        .utcOffset("+05:30")
                        .format("hh:mm A, DD MMM YYYY")}
                    </div>
                  </div>
                ))}
          </React.Fragment>
        ))}
      </div>

      <div
        className={` ${
          states?.consentData?.consents?.length > 0
            ? "mt-8 md:mt-14"
            : "mt-39px"
        } flex w-full flex-col`}
      >
        {states?.consentData?.otherConsents?.length > 0 && (
          <>
            <div className="flex w-full max-w-224.5 items-center justify-between px-3 md:px-0">
              <div className="font-MontserratSemiBold text-ft13-15.85-0.26 md:pl-12.5 md:text-ft15-22.5-0.3">
                No Consent
              </div>
              <div className="mr-14 font-MontserratSemiBold text-ft13-15.85-0.26 md:mr-0 md:w-37 md:pl-12.5 md:text-ft15-22.5-0.3">
                Updated on
              </div>
            </div>
            <div className="md:pr-7.5">
              <hr className="mb-2.5 mt-3 text-grey-E3E3E3 md:mb-4 md:mt-21px" />
            </div>
          </>
        )}
      </div>

      <div className="flex w-full flex-col gap-3 md:pl-12.5 md:pr-2">
        {states?.consentData?.otherConsents?.map((element) => (
          <React.Fragment key={element?.key?._id}>
            <div className="flex w-full max-w-224.5 items-center justify-between px-3 md:px-0">
              <div className="font-PoppinsRegular text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                {element.key.name}
              </div>
              <div className="font-PoppinsRegular text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                {moment(element.updatedOn)
                  .utcOffset("+05:30")
                  .format("hh:mm A, DD MMM YYYY")}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

ConsentDetailComponent.propTypes = {
  states: PropTypes
};

export default ConsentDetailComponent;
